// A simple "SS" logo for you.
export function SarthakMark(props: React.ComponentProps<"svg">) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 100" {...props}>
      <text
        x="50%"
        y="55%"
        dominantBaseline="middle"
        textAnchor="middle"
        fontSize="60"
        fontFamily="var(--font-pixel), monospace"
        fontWeight="bold"
        fill="currentColor"
      >
        SS
      </text>
    </svg>
  );
}

// You can ignore this function if you remove the context menu.
export function getMarkSVG(color: string) {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 100"><text x="50%" y="55%" dominant-baseline="middle" text-anchor="middle" font-size="60" font-family="var(--font-pixel), monospace" font-weight="bold" fill="${color}">SS</text></svg>`;
}
